export default __webpack_public_path__ + "static/media/right_page_icon.5beb5ca8.svg";